import { Communicator } from "./databin$"
import { CoordinatorService } from "./coordinator.service"
import { BehaviorSubject, Subject } from "rxjs"
import { XItem } from "./x-item"

export class LinkCommunicator {
    tag = "link"
    buttonCommunicator$ = new Subject()
 
    url: string = ""

    constructor(public coords: CoordinatorService) {

    }

    get connection() {
        return this.coords.databin$.editedConnection$.getValue()!
    }

}
